<template>
  <div class="sm:col-span-6">
    <div class="mt-1 sm:col-span-2 sm:mt-0 flex items-baseline mb-4">
      <input
        :id="id"
        :name="id"
        :type="type"
        :required="required"
        class="input-primary mb-2 mr-8 text-bkk-100 focus:ring-bkk-60 shrink-0"
        :class="[
          !errorMessage
            ? ' shadow-sm focus:border-bkk-100 focus:ring-bkk-100 sm:text-sm'
            : 'border-red-300 pr-10 text-red-900 placeholder-red-300 focus:border-red-500 focus:outline-none focus:ring-red-500 ',
        ]"
        @input="validate"
      />

      <label
        :for="id"
        class="block text-sm font-medium text-gray-700 pb-1"
        v-html="labelText"
      ></label>
      <div
        v-if="errorMessage"
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
      >
        <ExclamationCircleIcon
          class="h-5 w-5 text-red-500"
          aria-hidden="true"
        />
      </div>
    </div>
    <p v-if="errorMessage" class="mt-2 text-sm text-action-red">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
import { ExclamationCircleIcon } from "@heroicons/vue/solid";

export default {
  name: "CheckboxElement",
  components: {
    ExclamationCircleIcon,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    modelValue: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    validation: {
      type: Function,
      default: () => true,
    },
    errorMessage: {
      type: String,
      default: "",
    },
    errorKey: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue", "update-field"],
  data() {
    return {
      error: false,
    };
  },
  computed: {
    labelText() {
      return `${this.label} ${this.required ? "*" : ""}`;
    },
  },
  mounted() {
    this.error = this.errorMessage;
  },
  methods: {
    validate(event) {
      this.error = !this.validation(event.target.value);
      let value = event.target.checked;
      this.$emit("update-field", value);
    },
  },
};
</script>

<style>
label a {
  text-decoration: underline;
}
</style>
